import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TasaValidacionCostoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TASA VALIDACION COSTO' htmlFor='input-tasaValidacionCosto' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tasaValidacionCosto'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-tasaValidacionCosto'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TasaValidacionCostoFormGroup)
